module.exports = __webpack_public_path__ + "static/img/detail_liked.9217e11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product-detail/detail_liked.png
// module id = MLNN
// module chunks = 4